import vuetify from "@/main";
import DistributionMain from "./DistributionMain.vue";
import BillingPayment from "./BillingPayment.vue";
angular.module('leanlaw').config(['$stateProvider', $stateProvider => {
  $stateProvider.state('billing.distribution', {
    url: "/distribution",
    views: {
      '': {
        ...vuetify(DistributionMain)
      }
    }
  }).state('billing.distributionPayments', {
    url: "/distributionPayments",
    views: {
      '': {
        ...vuetify(BillingPayment)
      }
    }
  });
}]);